import classNames from 'classnames';
import { forwardRef, HTMLProps } from 'react';

import style from './input.module.css';

interface InputProps extends Omit<HTMLProps<HTMLInputElement>, 'className'> {
  containerClassName?: string;
  hideLabel?: boolean;
  inputClassName?: string;
  label: string;
  labelId?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({
    containerClassName,
    hideLabel,
    inputClassName,
    label,
    labelId,
    ...inputProps
  }, ref) => {
    const inputLabel = inputProps.required && !label.endsWith('*')
      ? `${label} *`
      : label;
    const InputComponent = (
      <input
        aria-label={hideLabel ? label : undefined}
        aria-required={inputProps['aria-required'] ?? inputProps.required}
        className={classNames(
          style.input,
          {
            [style.inputWithoutLabel]: hideLabel,
          },
          inputClassName,
        )}
        {...inputProps}
        ref={ref}
      />
    );

    return inputProps.type === 'hidden'
      ? InputComponent
      : (
        <label
          className={classNames(style.label, containerClassName)}
          id={labelId}
        >
          {!hideLabel && inputLabel}

          {InputComponent}
        </label>
      );
  },
);

export default Input;
